<template>
  <div class="domian-confirm-order">
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>域名注册</h2>
        <ul>
          <li>
            <i class="step">1</i>添加清单</li>
          <li>
            <i class="step">2</i>确认订单</li>
          <li>
            <i>3</i>在线支付</li>
          <li>
            <i>4</i>支付成功</li>
        </ul>
      </div>
    </div>
    <div class="con-wrap w1200">
      <div v-if="isError"
           class="error-box">
        {{errorMsg}}
      </div>
      <div v-else>
        <div v-if="isNoBuy">
          <!-- <back title="订单支付"></back> -->
          <!-- <steps :step="1"></steps> -->

          <div class="confirm-table-body">
            <div id="settlementTable"
                 class="settlement-table">
              <el-table :data="data.orderStatementItemList"
                        style="width: 100%">
                <el-table-column label="产品/扩展/服务">
                  <template slot-scope="scope">
                    <span class="g0 f14">{{scope.row.goodsName}}</span>
                    <span class="g0 domain"
                          v-if="scope.row.mainInstanceDomain">{{scope.row.mainInstanceDomain}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="购买数量/年限"
                                 width="200">
                  <template slot-scope="scope">
                    <span class="tl g3"
                          v-if="scope.row.isSupportNum">
                      <span v-if="scope.row.isSupportNum">{{scope.row.goodsNum}}{{scope.row.goodsNumUnit}}</span>
                      <span v-else>--</span>
                    </span>
                    <span class="tl g3"
                          v-if="scope.row.isSupportTime">
                      /
                      <span v-if="scope.row.isSupportTime">{{scope.row.timeLong}}{{scope.row.timeLongUnit}}</span>
                      <span v-else>--</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="单价"
                                 width="200">
                  <template slot-scope="scope">
                    <span class="tl g3 b">￥{{scope.row.basePrice | numToFix}}</span>
                  </template>
                </el-table-column>

                <el-table-column label="小计(元)"
                                 width="200">
                  <template slot-scope="scope">
                    <span class="tl g3 b">￥{{scope.row.sumPrice | numToFix}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <protocol @input="changeChecked"
                      :acceptAgreement="acceptAgreement"></protocol>
          </div>

          <div class="pay-footer">
            <div class="pf-body clearfix">
              <div class="fnbottom fl">
                <div class="fl">
                  <p class="f14">
                    <span> 金额： </span>
                    <span class="orange f24">￥{{data.realAmount | numToFix}}</span>
                  </p>
                  <p class="confirm-extended f12 g9">
                    <span>共</span>
                    <span class="orange mlr5">{{data.orderStatementItemList && data.orderStatementItemList.length}}</span>
                    <span> 产品/扩展/服务 </span>
                  </p>
                </div>
              </div>
              <div class="fr tr mt40 settlement-btn">
                <el-button @click="goBack">返回上一步</el-button>
                <el-button type="primary"
                           v-show="!isloading"
                           @click="confirmPay"
                           :disabled="!acceptAgreement">确认订单</el-button>
                <el-button v-show="isloading"
                           class="ml0"
                           type="primary"
                           :loading="true">加载中</el-button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isBuy">
          <pay-success :sdata="orderDetail"
                       :config="psConfig"></pay-success>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import protocol from './components/Protocol'
import numToFix from './util/num-tofix'

export default {
  data () {
    return {
      acceptAgreement: true,
      isBuy: false,
      isNoBuy: true,
      isloading: false,
      isError: false,
      orderDetail: {},
      psConfig: {
        showOrderListBtn: false,
        repeatBuy: true
      },
      data: {
        orderStatementItemList: []
      }
    }
  },
  components: {
    protocol
  },
  filters: {
    numToFix
  },
  methods: {
    confirmPay () {
      this.isloading = true
      let params = {
        source: 0,
        orderDeatil: []
      }
      // 1: 新购， 2: 续费
      var newBuyData = JSON.parse(this.$route.params.data)
      var isSyncMainTime = newBuyData && newBuyData[0].isSyncMainTime
      var isRenew = newBuyData && newBuyData[0].businessType == 2

      this.data.orderStatementItemList.forEach((v, i, arr) => {
        params.orderDeatil[i] = {}
        params.orderDeatil[i].skuId = v.skuId
        params.orderDeatil[i].goodsId = v.goodsId
        params.orderDeatil[i].instanceCode = v.instanceCode
        params.orderDeatil[i].timeFlag = isRenew ? '' : isSyncMainTime
        params.orderDeatil[i].NUM = v.goodsNum ? v.goodsNum : ''
        params.orderDeatil[i].TIME_LONG = v.timeLong ? v.timeLong : ''
      })
      $.post('/order/savecommonorders', {
        data: JSON.stringify(params)
      }).then(
        res => {
          console.log(res)
          this.isloading = false
          if (!res.status) {
            // this.$router.push({
            //   path: `/domain/payment/selPay/${res.orderid}`
            // })
            window.open(`/payment/index.html?orderid=${res.orderid}`)
          } else {
            this.$message.error('确认订单失败！')
          }
        },
        res => {
          this.isloading = false
          this.IsDisabled = false

          if (err.status == '229') {
            this.$alert(err.msg, '', {
              confirmButtonText: '确定'
            })
          }
        }
      )
    },
    filterNum (item) {
      // 过滤数据
    },
    goBack () {
      this.$router.go(-1)
    },
    changeChecked (v) {
      this.acceptAgreement = v
    }
  },
  created () {
    $.get('/order/settlements1', this.$route.params).then(res => {
      this.data = res.orderStatement
    })
  }
}
</script>
<style  lang="scss">
@import "../static/css/confirm-order.scss";
</style>





// WEBPACK FOOTER //
// src/confirm-order.vue